export const ROUTES = {
  login: "/login",
  tenants: "/tenants",
  tenant: (id: string) => `/tenants/${id}`,
  /**
   * The device console (M9 §6). Deliberately NOT in the sidebar: it is reached from a terminal row on the
   * tenant page or the fleet, so an operator always arrives at it knowing whose building it reaches into.
   */
  deviceConsole: (tenantId: string, deviceId: string) => `/tenants/${tenantId}/devices/${deviceId}/console`,
  /** M11 (ADR-0015 §5): money across organisations, and the catalogue everyone is priced from. */
  billing: "/billing",
  catalogue: "/catalogue",
  /** M20 (ADR-0024): the platform's SMS price and limits, the templates registry, and the delivery backlog. */
  sms: "/sms",
  smsTemplates: "/sms/templates",
  smsMessages: "/sms/messages",
  mobileReleases: "/mobile-releases",
  /** The backlog narrowed to one status (linked from the overview strip). */
  smsMessagesWith: (status: string) => `/sms/messages?status=${status}`,
  /**
   * M26 (ADR-0031, contracts §22): Payroll law — the platform's statutory rule sets and tax years, and the
   * readiness list. `/payroll-law` holds the three tabs (`?tab=rule-sets|tax-years|readiness`); a set or a year
   * opens on its own address, so a published figure can be linked from a support ticket.
   */
  payrollLaw: "/payroll-law",
  payrollLawRuleSet: (id: string) => `/payroll-law/rule-sets/${id}`,
  payrollLawTaxYear: (id: string) => `/payroll-law/tax-years/${id}`,
  fleet: "/fleet",
  /** M14 follow-up (ADR-0007 addendum 2026-09-15): per-model terminal capacity. */
  deviceModels: "/device-models",
  unclaimed: "/unclaimed",
  queues: "/queues",
  audit: "/audit",
  /** The audit timeline filtered to one organisation (linked from the tenant page). */
  auditForTenant: (tenantId: string) => `/audit?tenantId=${tenantId}`,
  operators: "/operators",
  reviewers: "/reviewers",
} as const;
